module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAsBAMAAADlQedIAAAAJ1BMVEUAAAD////////////////8AwL////////9DAz9Bgb8IiL7Gxv9AQCQrWnEAAAADHRSTlMABgsQFMEYHYWCSkd8cukTAAABCUlEQVQoz72RMW4CMRBF1zcY+wY7W0Xp1o4URekccQFEEYkShRvAAdKmipQuHS0Vd0BC4EMxs4N3bAo6+J2f3h/LnuaeMQ2YawZgLQDUzA65KgssVUMMn36RVChFh/8nbIlW7DmlHallG7v3lKY9FlNJ9POU9p4GqOi610T57nUqtf0Pw4NHm+siZlUot7cCjwRH8y1dslETXzKcIpsC/2bCZp+oZljOme1X8cGQUsO8NBcmAhexHU3XZTi+HUo4msZ1QWDs28yMVVj9/GS5Xq8Ww8/r0PBFiXwPFNv8oPA2TTZ57z5E32ubTMuUmYWSOqTw1jWGXfKkrVOHgGkqqkwz9GpGZ05zK2dg3pB4/vNbawAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd128/red.png
// module id = Dlu2
// module chunks = 1